import {makeGameRequest} from "./ui-helpers.js";
import {deleteAllMessages, deleteMessage, getMessages, setMessageRead} from "../modules/messages.js";
import {checkTutorialStepAction} from "./tutorial.js";
import {globals} from "../modules/globals.js";

async function messageClickHandler() {
    $("#main-menu-right").html('');
    $('.main-menu-container').find('li').removeClass('selected');
    await makeGameRequest(getMessages, {}, showGetMessagesData, {});
}

$(document).ready(function () {

    // Message filters
    $('.messages-filter-button').on('click', function () {

        // Reset if unselecting
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
            $('.message-preview-item').show();
            $('.no-messages-found').hide();
            checkEmptyMessages();
            return false;
        }

        // Select this item
        $('.messages-filter-button.selected').removeClass('selected');
        $(this).addClass('selected');

        let filterName = $(this).attr('data-filter-name');
        if (filterName === 'all') {
            $('.message-preview-item').show()
        }
        else if (filterName === 'unread') {
            $('.message-preview-item').each(function (i, el) {
                if ($(el).hasClass('unread')) {
                    $(el).show()
                }
                else {
                    $(el).hide()
                }
            })
        }
        else if (filterName === 'owner') {
            $('.message-preview-item').each(function (i, el) {
                if ($(el).find('.owner-tag-icon').length > 0) {
                    $(el).show()
                }
                else {
                    $(el).hide()
                }
            })
        }
        else if (filterName === 'staff') {
            $('.message-preview-item').each(function (i, el) {
                if ($(el).find('.staff-tag-icon').length > 0) {
                    $(el).show()
                }
                else {
                    $(el).hide()
                }
            })
        }
        else if (filterName === 'superstar') {
            $('.message-preview-item').each(function (i, el) {
                if ($(el).find('.superstar-tag-icon').length > 0) {
                    $(el).show()
                }
                else {
                    $(el).hide()
                }
            })
        }

        checkEmptyMessages();
    });

    // Delete message
    $('#game-messages').on('click', '.delete-message', async function () {
        let $el = $(this);
        let uid = parseInt($(this).closest('.message-header').attr('data-uid'));
        await makeGameRequest(deleteMessage, {uid}, showDeleteMessageData, {$el, uid}, false);
    });

    // Delete all messages
    $('.delete-all-messages-button').on('click', function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                await makeGameRequest(deleteAllMessages, {read: false}, showDeleteAllMessagesData, {read: false}, false);
            }
        });
    });

    // Delete read messages
    $('.delete-read-messages-button').on('click', function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                await makeGameRequest(deleteAllMessages, {read: true}, showDeleteAllMessagesData, {read: true}, false);
            }
        });
    });
});

async function showGetMessagesData({data} = {}) {
    let parent = $('#game-messages');

    // Reset
    parent.find('.message-preview-container').html('');
    parent.find('.message-content-box').html('').hide();
    parent.find('.messages-filter-button').removeClass('selected');
    parent.find('.messages-filter-button').eq(0).addClass('selected');

    // Get message preview items
    data['messages'].forEach(function (message) {
        let messagePreviewHtml = getMessagePreviewHtml(message);
        // Insert message preview item
        parent.find('.message-preview-container').append(messagePreviewHtml);
    });
    if (data['messages'].length > 3) {
        parent.find('.message-preview-item').last().addClass('last-without-border');
    }

    // Empty text
    if (data['messages'].length <= 0) {
        if ($('.no-messages-found').length < 1) {
            parent.find('.message-preview-container').append(
                '<div class="no-messages-found light-grey">No messages present</div>'
            );
        }
        else {
            $('.no-messages-found').show()
        }
    }

    // View message handler
    $('#game-messages').off('click', '.message-preview-item');
    $('#game-messages').on('click', '.message-preview-item', async function () {
        // Select this item
        parent.find('.message-preview-item.selected').removeClass('selected');
        $(this).addClass('selected');

        let uid = parseInt($(this).attr('data-uid'));
        let message = data['messages'].filter(function (message) {
            return message.uid === uid;
        })[0];
        let messageContentHtml = getMessageContentHtml(message);
        parent.find('.message-content-box').html(messageContentHtml).hide().fadeIn();
        parent.find(".message-content-container").scrollTop(0);

        // Update message read if not read
        if ($(this).hasClass('unread')) {
            await makeGameRequest(setMessageRead, {uid}, showSetMessageReadData, {}, false);
            $(this).removeClass('unread');
            $(this).find('.unread-image').remove();
        }

        if ($(this).find('.message-preview-subject').text().indexOf('Injury') >= 0) {
            // Tutorial action check
            checkTutorialStepAction('click_injury_message');
        }
    });

    $('#game-messages').fadeIn();

    // View first message
    parent.find('.message-preview-item').eq(0).trigger('click');
    parent.find(".message-preview-container").scrollTop(0);
    parent.find(".message-content-container").scrollTop(0);

    // Tutorial action check
    if (data['nextTutorialState']) {
        globals.game.tutorialState = data['nextTutorialState']
    }

    // Tutorial action check
    checkTutorialStepAction('click_messages_button');
}

function showDeleteAllMessagesData({read} = {}) {
    // Remove deleted messages, check empty messages text
    if (read) {
        $('.message-preview-item:not(.unread)').remove();
        notie.alert({type: 4, text: 'Read Messages deleted'});
    }
    else {
        $('.message-preview-item').remove();
        // Remove unread icon, reset unread messages to 0
        $('.messages-number').text('0');
        $('.messages-icon').attr('src', 'static/www/static/message_icon.png');
        notie.alert({type: 4, text: 'All Messages deleted'});
    }
    $('.message-content-box').html('').hide();
    checkEmptyMessages();

    // View first message
    $('.message-preview-item:visible').eq(0).trigger('click');
    $(".message-preview-container").scrollTop(0);
    $(".message-content-container").scrollTop(0);
}

function showSetMessageReadData() {
    let messagesNumber = parseInt($('.messages-number').text()) - 1;
    $('.messages-number').text(messagesNumber);
    if (messagesNumber <= 0) {
        $('.messages-icon').attr('src', 'static/www/static/message_icon.png')
    }
    return true;
}

function showDeleteMessageData({$el, uid} = {}) {
    // Remove message box
    $el.closest('.message-content-box').html('').hide();
    if ($('.message-content-box:visible').length <= 0) {
        // If no messages remaining in this message conversation, move to next message
        let messagePreviewItem = $('.message-preview-item[data-uid="' + uid + '"]');
        let index = $('.message-preview-item:visible').index(messagePreviewItem);
        messagePreviewItem.remove();
        if (index === ($('.message-preview-item:visible').length)) {
            index -= 1
        }
        $('.message-preview-item:visible').eq(index).trigger('click');
    }

    checkEmptyMessages();
}

function checkEmptyMessages() {
    // Show/hide no messages found text
    if ($('.message-preview-item:visible').length < 1) {
        if ($('.no-messages-found').length < 1) {
            $('.message-preview-container').append(
                '<div class="no-messages-found light-grey">No messages present</div>'
            );
        }
        else {
            $('.no-messages-found').show()
        }
    }
    else {
        $('.no-messages-found').hide()
    }
    return true;
}

function getMessageTagIcon(tag) {
    let tagIcon;
    switch (tag) {
        case 'owner':
            tagIcon = '<img alt="Owner" src="static/www/static/category_icon_gold.png" class="messages-filter-icon owner-tag-icon"/>';
            break;
        case 'staff':
            tagIcon = '<img alt="Staff" src="static/www/static/category_icon_green.png" class="messages-filter-icon staff-tag-icon"/>';
            break;
        case 'superstar':
            tagIcon = '<img alt="Superstar" src="static/www/static/category_icon_blue.png" class="messages-filter-icon superstar-tag-icon"/>';
            break;
    }
    return tagIcon
}

function getMessagePreviewHtml(message) {
    let unreadClass = '';
    let unreadIcon = '';
    let tagIcon = '';
    if (!message['read']) {
        unreadClass = ' unread';
        unreadIcon = '<img alt="Unread" src="static/www/static/unread_icon.png" class="unread-image"/>'
    }

    if (message['tag']) {
        tagIcon = getMessageTagIcon(message['tag'])
    }

    return '<div class="message-preview-item' + unreadClass + '" data-uid="' + message['uid'] + '">' +
        '<div class="message-preview-subject margin-bottom-5">' +
        message['subject'] + '<div class="message-preview-icons-container">' + unreadIcon + tagIcon + '</div>' +
        '</div>' +
        '<div class="message-preview-from light-grey">' + message['fromName'] + '</div>' +
        '</div>';
}

function getMessageContentHtml(message) {

    let monthsPassed = message['monthsPassed'];
    let monthsPassedText;
    if (monthsPassed === 0) {
        monthsPassedText = 'This month'
    }
    else if (monthsPassed === 1) {
        monthsPassedText = message['monthsPassed'] + ' month ago'
    }
    else {
        monthsPassedText = message['monthsPassed'] + ' months ago'
    }

    return '<div class="message-header light-grey margin-bottom-12" data-uid="' + message['uid'] + '">' +
        monthsPassedText +
        '<div class="float-right font-1p25em">' +
        '<i class="fa fa-trash delete-message cursor-pointer"></i>' +
        '</div>' +
        '</div>' +
        '<div class="message-content">' +
        message['content'] +
        '</div>' +
        '<div class="message-from light-grey">' +
        message['fromName'] +
        '</div>';
}

export {showGetMessagesData, messageClickHandler}